import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';

export const StripeTabNavigation = () => {
  const pageTabs: PageTabItem[] = [
    {
      label: 'invoice:autogiro.tabAutogiro',
      route: RoutesEnum.StripeCustomer,
    },
    {
      label: 'invoice:autogiro.tabMemberautogirostatus',
      route: RoutesEnum.MemberStripeStatus,
    },
  ];

  return <PageTabNavigation pageTabs={pageTabs} />;
};
